/* Foto met hotspots: een klik op een hotspot toont het bijbehorende product in de kaart */
if (!customElements.get('ts-hotspots')) {
    customElements.define('ts-hotspots', class extends HTMLElement {
        connectedCallback() {
            if (this.initialized) return;
            this.initialized = true;
            this.dots = [...this.querySelectorAll('.ts-hs__dot')];
            this.cards = [...this.querySelectorAll('.ts-hs__card')];
            this.dots.forEach((dot) => dot.addEventListener('click', () => this.select(Number(dot.dataset.index))));

            /* Theme-editor: geselecteerde hotspot tonen */
            document.addEventListener('shopify:block:select', (e) => {
                const i = this.dots.indexOf(e.target);
                if (i > -1) this.select(i);
            });
        }

        select(index) {
            this.dots.forEach((dot, i) => {
                dot.classList.toggle('is-active', i === index);
                dot.setAttribute('aria-pressed', String(i === index));
            });
            this.cards.forEach((card, i) => { card.hidden = i !== index; });
        }
    });
}
